module.exports = __webpack_public_path__ + "static/media/Icon-awesome-pen-fancy-writen.97cf1add.svg";